// ReactJs
import React from 'react'
// Node modules
import styled from 'styled-components'
// Styles
import ToggleItem from '@shared/components/ToggleItem'
import { incrementStatistic } from '../../services'

const FaqListContainer = styled.div`
  min-width: 275px;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.133333px;
`

export default function FaqList({ faqs }) {
  return (
    <FaqListContainer>
      { faqs && faqs.map((item, index) => {
        const question = item.title
        const answer = item.content
        return (
          <ToggleItem key={ index } title={ question } content={ answer }
                      onOpen={ () => {
                        return incrementStatistic('FAQ_QUESTION', question.replace(".", "\u2024"))
                      } }/>
        )
      }) }
    </FaqListContainer>
  )
}
